import { f as fetchHTML } from './index-Da0J-i1G.js';

class CollectionGrid extends HTMLElement {
  abortController;

  connectedCallback() {
    this.unsubscribeSortChanged = subscribe('sort:changed', () => this.handleSortChange());
    this.unsubscribeFiltersUpdated = subscribe('filters:updated', () => this.handleSortChange());
  }

  disconnectedCallback() {
    this.unsubscribeSortChanged();
    this.unsubscribeFiltersUpdated();
  }

  /**
   * Handle sort change
   */
  async handleSortChange() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const searchParams = new URLSearchParams(window.location.search);

    try {
      const html = await fetchHTML(
        `${window.location.pathname}?section_id=main-collection&${searchParams}`
      );

      this.renderProductGrid(html);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Render product grid
   * @param {HTMLElement} html - HTML to render
   */
  renderProductGrid(html) {
    const parsedCollectionGrid = html.querySelector('collection-grid');

    this.innerHTML = parsedCollectionGrid.innerHTML;
  }
}

customElements.define('collection-grid', CollectionGrid);
